import React from 'react';
import { format } from 'date-fns';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';

const TransactionsTable = ({
    transactions,
    isLoading,
    getTransactionTypeLabel,
    formatTransactionId,
    formatReferenceId,
    formatStripeId
}) => {
    const getStatusColor = (type, amount) => {
        if (type === 'credit_purchase') return 'text-green-600 dark:text-green-400';
        if (type === 'analysis_refund') return 'text-blue-600 dark:text-blue-400';
        return amount > 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400';
    };

    const getTypeStyles = (type) => {
        const styles = {
            'credit_purchase': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
            'analysis_refund': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
            'analysis': 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
            'custom_type_creation': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200 text-nowrap'
        };
        return `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${styles[type] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200'}`;
    };

    if (isLoading) {
        return (
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead className="w-[180px]">Transaction ID</TableHead>
                        <TableHead className="w-[150px]">Date</TableHead>
                        <TableHead className="w-[150px]">Credits</TableHead>
                        <TableHead className="w-[200px]">Type</TableHead>
                        <TableHead className="w-[150px]">Reference</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {Array(5).fill(0).map((_, i) => (
                        <TableRow key={i}>
                            <TableCell className="py-4"><Skeleton className="h-4 w-24" /></TableCell>
                            <TableCell className="py-4"><Skeleton className="h-4 w-32" /></TableCell>
                            <TableCell className="py-4"><Skeleton className="h-4 w-16" /></TableCell>
                            <TableCell className="py-4"><Skeleton className="h-4 w-32" /></TableCell>
                            <TableCell className="py-4"><Skeleton className="h-4 w-24" /></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead className="w-[180px] min-w-32">Transaction ID</TableHead>
                    <TableHead className="w-[150px] min-w-32">Date</TableHead>
                    <TableHead className="w-[150px] min-w-32">Credits</TableHead>
                    <TableHead className="w-[200px] min-w-32">Type</TableHead>
                    <TableHead className="w-[150px] min-w-32">Reference</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {transactions.map((transaction) => (
                    <TableRow key={transaction.id}>
                        <TableCell className="font-medium py-3">
                            {formatTransactionId(transaction.id)}
                        </TableCell>
                        <TableCell className="py-3">
                            {format(new Date(transaction.created_at), 'MMM dd, yyyy')}
                        </TableCell>
                        <TableCell className={`py-3 ${getStatusColor(transaction.transaction_type, transaction.amount)}`}>
                            {transaction.amount > 0 ? '+' : ''}{transaction.amount.toLocaleString()} credits
                        </TableCell>
                        <TableCell className="py-3">
                            <span className={getTypeStyles(transaction.transaction_type)}>
                                {getTransactionTypeLabel(transaction.transaction_type)}
                            </span>
                        </TableCell>
                        <TableCell className="text-muted-foreground py-3">
                            {transaction.reference_id ? formatReferenceId(transaction.reference_id) :
                                transaction.stripe_payment_id ? formatStripeId(transaction.stripe_payment_id) :
                                    '-'}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default TransactionsTable;